module.exports = __webpack_public_path__ + "static/img/advantage1.ac8f43a5.png";